import { CtaButton, LinkButton } from "@components/button"
import { FlexBox } from "@components/wrapper"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@constants/const/pictures"
import { IMAGE_COVER } from "@constants/styles"
import { BannerInfo } from "@interfaces/misc"
import clsx from "clsx"
import { AppImage as Image } from "@components/misc"
import { FC } from "react"
import { BsDot } from "react-icons/bs"

export const HomeBanner: FC<{ info: BannerInfo | null }> = ({ info }) => {
  function numberFormatter(value: number) {
    return new Intl.NumberFormat("id-ID").format(value)
  }

  return (
    <section className="relative w-full">
      <div className="relative w-full isolate">
        <FlexBox
          className={clsx(
            "font-inter relative z-10 w-full text-white",
            "bg-[rgba(0,0,0,0.85)] sm:pt-[74px]"
          )}
          justify="center"
          align="center"
          direction="col"
        >
          <div className="flex flex-col items-center w-fit sm:py-16 py-10">
            <div className="text-sm mb-8">*Updated: {info?.last_updated_local_date}</div>

            <h1
              id="hp-banner"
              className={clsx(
                "font-urbanist sm:text-[64px] text-white font-bold text-center leading-[130%]",
                "text-4xl mb-5"
              )}
            >
              Dapat Kerja <br className="sm:hidden" /> Lebih Cepat <br className="sm-only:my-0" />{" "}
              <span className="text-new-green">
                Belajar dengan AI & <br /> WorkVenture-based Learning
              </span>
            </h1>

            <div className="flex flex-col items-center w-fit sm:gap-10 gap-8">
              <p className={clsx("font-inter sm:w-2/5 w-3/4", "text-center sm-only:text-xs")}>
                Bergabung dengan {numberFormatter(info?.total_alumni || 0)}* alumni yang bekerja di
                perusahaan TOP di Indonesia dan mancanegara. Kuasai skill masa depan dengan bantuan
                AI dan metode <b>WorkVenture-based Learning</b> harisenin.com
              </p>

              <FlexBox className={clsx("sm:gap-3", "sm-only:justify-center")} align="center">
                <div className="sm-only:hidden relative sm:h-[42px] sm:w-20">
                  {info?.user_picture.map((picture, index) => (
                    <div
                      key={index}
                      className={clsx(
                        "rounded-full border-2 border-new-blue absolute top-0 right-0",
                        index === 1 && "sm:right-[20px] right-[4px]",
                        index === 2 && "sm:right-[40px] right-[10px]",
                        index === 3 && "sm:right-[60px] right-[16px]",
                        index === 4 && "sm:right-[80px] right-[16px]",
                        "sm:w-[42px] sm:h-[42px] wh-7"
                      )}
                    >
                      <Image
                        src={picture}
                        width={42}
                        height={42}
                        alt="User Picture"
                        className={clsx(IMAGE_COVER, "sm:wh-full")}
                      />
                    </div>
                  ))}
                </div>

                <FlexBox className="gap-[2px] text-sm" align="center">
                  <span>⭐ </span>{" "}
                  <span className="font-bold sm-only:text-xs">{info?.average_rating}/5</span>{" "}
                  <span>
                    <BsDot />
                  </span>{" "}
                  <span className="sm-only:text-xs font-inter">
                    Review dari {numberFormatter(info?.total_alumni || 0)}+ Alumni
                  </span>
                </FlexBox>
              </FlexBox>

              <CtaButton />
            </div>
          </div>
        </FlexBox>

        {/* The collage sits at the image edges; below `sm` object-cover crops to its empty centre,
            so the image is only shown (and fetched at full size) from `sm` up. */}
        <div className="pointer-events-none absolute inset-0 z-0 hidden sm:block" aria-hidden>
          <Image
            fill
            src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/homepage_hero-banner.webp`}
            width={1468}
            height={724}
            sizes="(min-width: 640px) 100vw, 16px"
            alt=""
            className="object-cover bg-black"
            priority
            fetchPriority="high"
          />
        </div>
      </div>
    </section>
  )
}
